// Specification Pattern

abstract class Specification<T> {
    abstract type: string;
    abstract isSatisfiedBy(candidate: T): boolean;
  }
  class OnlyPriceSpec extends Specification<any> {
    type = "OnlyPrice";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
  }
  
  class PriceWithPixSpec extends Specification<any> {
    type = "PriceWithPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
     }
  }
  class PriceWithDiscountCodeSpec extends Specification<any> {
    type = "PriceWithDiscountCode";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
  
     }
  }
  class PriceWithMarkdownSpec extends Specification<any> {
    type = "PriceWithMarkdown";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
     }
  }
  class PriceWithDiscountCodeAndPixSpec extends Specification<any> {
    type = "PriceWithDiscountCodeAndPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
     }
  }
  
  class PriceWithMarkdownAndPixSpec extends Specification<any> {
    type = "PriceWithMarkdownAndPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
  }
  class PriceWithMarkdownAndDiscountCodeSpec extends Specification<any> {
    type = "PriceWithMarkdownAndDiscountCode";
    isSatisfiedBy(candidate: any): boolean { 
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
      }
  }
  class PriceWithMarkdownAndDiscountCodeAndPixSpec extends Specification<any> {
    type = "PriceWithMarkdownAndDiscountCodeAndPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
     }
  }
  class PriceWithPointsSpec extends Specification<any> {
    type = "PriceWithPoints";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }
  }
  class PriceWithPointsAndPixSpec extends Specification<any> {
    type = "PriceWithPointsAndPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }
  }
  class PriceWithPointsAndMarkdownSpec extends Specification<any> {
    type = "PriceWithPointsAndMarkdown";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }  
  }
  class PriceWithPointsAndMarkdownAndPixSpec extends Specification<any> {
    type = "PriceWithPointsAndMarkdownAndPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }
  }
  class PriceWithCashbackSpec extends Specification<any> {
    type = "PriceWithCashback";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }  
  }
  class PriceWithCashbackAndPixSpec extends Specification<any> {
    type = "PriceWithCashbackAndPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }
  }
  class PriceWithCashbackAndMarkdownSpec extends Specification<any> {
    type = "PriceWithCashbackAndMarkdown";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }
  }
  class PriceWithCashbackAndMarkdownAndPixSpec extends Specification<any> {
    type = "PriceWithCashbackAndMarkdownAndPix";
    isSatisfiedBy(candidate: any): boolean { 
      return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }
  }
  
  const allSpecs: Specification<any>[] = [
    new PriceWithMarkdownAndDiscountCodeAndPixSpec(),
    new PriceWithMarkdownAndDiscountCodeSpec(),
    new PriceWithMarkdownAndPixSpec(),
    new PriceWithMarkdownSpec(),
    new PriceWithDiscountCodeSpec(),
    new PriceWithDiscountCodeAndPixSpec(),
    new PriceWithPointsAndMarkdownAndPixSpec(),
    new PriceWithPointsAndMarkdownSpec(),
    new PriceWithPointsAndPixSpec(),
    new PriceWithPointsSpec(),
    new PriceWithCashbackAndMarkdownAndPixSpec(),
    new PriceWithCashbackAndMarkdownSpec(),
    new PriceWithCashbackAndPixSpec(),
    new PriceWithCashbackSpec(),
    new PriceWithPixSpec(),
    new OnlyPriceSpec(),
  ];
  
  function resolveType(candidate: any): string | undefined {
    const spec = allSpecs.find(s => s.isSatisfiedBy(candidate));
    return spec?.type;
  }
  
  if (typeof window !== "undefined") {
    (window as any).PriceNormalizeResolveType = resolveType;
  }